/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfRegistrationConfigDto } from '../../models/platform-api-result-of-registration-config-dto';
import { PlatformSetRegistrationEnabled } from '../../models/platform-set-registration-enabled';

export interface PostUseraccountsActionSetRegistrationEnabled$Params {
      body: PlatformSetRegistrationEnabled
}

export function postUseraccountsActionSetRegistrationEnabled(http: HttpClient, rootUrl: string, params: PostUseraccountsActionSetRegistrationEnabled$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionSetRegistrationEnabled.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfRegistrationConfigDto>;
    })
  );
}

postUseraccountsActionSetRegistrationEnabled.PATH = '/api/useraccounts/action/set-registration-enabled';
